import React, { useState } from 'react';
import { Container, Paper, Typography, Button, Box, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

function Quizzes() {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [showScore, setShowScore] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState('');

  const questions = [
    {
      question: 'What does "Bonjour" mean?',
      options: ['Goodbye', 'Hello', 'Thank you', 'Please'],
      correctAnswer: 'Hello'
    },
    {
      question: 'What does "Au revoir" mean?',
      options: ['Hello', 'Thank you', 'Goodbye', 'Please'],
      correctAnswer: 'Goodbye'
    },
    {
      question: 'What does "Merci" mean?',
      options: ['Hello', 'Goodbye', 'Please', 'Thank you'],
      correctAnswer: 'Thank you'
    }
  ];

  const handleAnswerSubmit = () => {
    if (selectedAnswer === questions[currentQuestion].correctAnswer) {
      setScore(score + 1);
    }

    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < questions.length) {
      setCurrentQuestion(nextQuestion);
      setSelectedAnswer('');
    } else {
      setShowScore(true);
    }
  };

  const handleRestart = () => {
    setCurrentQuestion(0);
    setScore(0);
    setShowScore(false);
    setSelectedAnswer('');
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        {showScore ? (
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h4" gutterBottom>
              Quiz Completed!
            </Typography>
            <Typography variant="h5" gutterBottom>
              Your Score: {score} out of {questions.length}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleRestart}
              sx={{ mt: 2 }}
            >
              Restart Quiz
            </Button>
          </Box>
        ) : (
          <>
            <Typography variant="h4" gutterBottom>
              Question {currentQuestion + 1} of {questions.length}
            </Typography>
            <Typography variant="h5" gutterBottom>
              {questions[currentQuestion].question}
            </Typography>

            <FormControl component="fieldset" sx={{ mt: 2 }}>
              <FormLabel component="legend">Select your answer:</FormLabel>
              <RadioGroup
                value={selectedAnswer}
                onChange={(e) => setSelectedAnswer(e.target.value)}
              >
                {questions[currentQuestion].options.map((option, index) => (
                  <FormControlLabel
                    key={index}
                    value={option}
                    control={<Radio />}
                    label={option}
                  />
                ))}
              </RadioGroup>
            </FormControl>

            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAnswerSubmit}
                disabled={!selectedAnswer}
              >
                Submit Answer
              </Button>
            </Box>

            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body1">
                Current Score: {score}
              </Typography>
              <Typography variant="body1">
                Questions Remaining: {questions.length - currentQuestion - 1}
              </Typography>
            </Box>
          </>
        )}
      </Paper>
    </Container>
  );
}

export default Quizzes; 